import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const brands = new RepositoryFactory('brands');

export default {
  namespaced: true,
  state: {
    // Single user
    brand: {},
    brands: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
    createError: '',
    deleteError: false,
    updateError: false,
  },
  getters: {
    getBrand(state) {
      return state.brand;
    },
    getBrands(state) {
      const brands = [];
      for (const iterator of state.brands) {
        if (iterator.branch) {
          iterator.branchName = iterator.branch.name;
          brands.push(iterator);
        }
      }
      return brands;
    },
    getAllBrands(state) {
      return state.brands;
    },
    getBrandsTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
    getError(state) {
      return state.error;
    },
    getCreateError(state) {
      if (state.createError) {
        return state.createError.message;
      } else {
        return '';
      }
    },
  },
  mutations: {
    SET_BRAND(state, data) {
      state.brand = data;
    },
    SET_BRANDS(state, data) {
      state.brands = data.items;
      state.total = data.totalOfItems;
      state.totalPages = data.pageCount || 0;
    },
    SET_ALL_BRANDS(state, data) {
      state.brands = data;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_CREATE_ERROR(state, error) {
      state.createError = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getBrands');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getBrands');
    },
    searchBrand: async ({ commit }, payload) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await brands.getWithSearch(payload.search, payload.extraParams);
        commit('SET_BRANDS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    resetCreateError: ({ commit }) => {
      commit('SET_CREATE_ERROR', null);
    },
    createBrand: async ({ commit, dispatch }, payload) => {
      commit('SET_CREATE_ERROR', '');
      try {
        const res = await brands.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Marca criada com sucesso!',
        });
        dispatch('getBrands');
        return res.data.id;
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
        commit('SET_CREATE_ERROR', error.response.data);
      }
    },
    update: async ({ dispatch }, payload) => {
      try {
        await brands.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Marca atualizada com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
    },
    getBrandById: async ({ commit }, id) => {
      try {
        const { data } = await brands.getById(id);
        commit('SET_BRAND', data);
        return data;
      } catch (error) {}
    },
    getBrands: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await brands.get(state.currentPage);
        commit('SET_BRANDS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getBrandsNoLimit: async ({ commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await brands.get();
        commit('SET_ALL_BRANDS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
